import { NgModule } from '@angular/core';
import { HedaCoreUtilModule } from '@heda/core-util';
import { TemplateService } from 'app/mdm/template/services/template.service';

@NgModule({
  imports: [HedaCoreUtilModule],
  providers: [TemplateService],
})
export class TemplateLibModule {}
